import React, { useEffect, useState } from 'react'
import DrawerDapp from './DrawerDapp';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { app, db, storages } from "../../firebaseConfig/firebaseConfig";
import {  doc, getDoc, updateDoc } from 'firebase/firestore/lite';
import {ref, uploadString, uploadBytes, getDownloadURL,deleteObject , uploadBytesResumable } from 'firebase/storage'
import { useHistory } from "react-router-dom";


import {  useParams,Redirect } from 'react-router-dom';

export const DappMenuSreen = () => {


const { id } = useParams();


  const history = useHistory();

  const user = localStorage.getItem('email')
    const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [name, setname] = useState();
  const [img, setImage] = useState();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getInfo();
    return () => {
      
    }
  }, [])


  const getInfo = async () => {
    const myuser = localStorage.getItem("uid");
    console.log(myuser);
    const docRef = doc(db, "users", myuser);
    const docSnap = await getDoc(docRef);


    if (!docSnap.exists) {
        console.log('No such document!');
    } else {
        console.log('Document data:', docSnap.data());
        //name = docSnap.data().name;
        let data = docSnap.data();
        console.log(data.name, "dede")
        setname(data.name);
        if(data.img != undefined){
            setImage(data.img);
            localStorage.setItem("image",data.img);
            console.log(data.img);
            
        }

    }
}

const goToProfile =  () => {

  history.push("/dapp/profile");
}


const logout = () => {
  localStorage.clear();

  history.push("/");

}





    return (
        <div className="dapp__menu">
        <div className="dapp__logo">

<DrawerDapp/>
{localStorage.getItem("red") == "ropsten" &&
<div className="dapp__red">
  
<p style={{"fontSize":"14px"}}>Ropsten</p>
{!id && 
<img style={{"width":"30px"}} src="../assets/rop.png"></img>
 }
 {id && 
<img style={{"width":"30px"}} src="../../assets/rop.png"></img>
 }
</div>

}

{localStorage.getItem("red") == "xdai" &&
<div className="dapp__red">
  
<p style={{"fontSize":"14px"}}>Xdai</p>
{!id && 
<img style={{"width":"30px"}} src="../assets/xdai.png"></img>
 }
 {id && 
<img style={{"width":"30px"}} src="../../assets/xdai.png"></img>
 }

</div>

}

{localStorage.getItem("red") == "binance" &&
<div className="dapp__red">
  
<p style={{"fontSize":"14px"}}>Binance</p>
{!id && 
<img style={{"width":"30px"}} src="../assets/binance.png"></img>
 }
 {id && 
<img style={{"width":"30px"}} src="../../assets/binance.png"></img>
 }



</div>

}

{localStorage.getItem("red") == "polygon" &&
<div className="dapp__red">
  
<p style={{"fontSize":"14px"}}>Polygon</p>

{!id && 
<img style={{"width":"30px"}} src="../assets/poly.svg"></img>
 }
 {id && 
<img style={{"width":"30px"}} src="../../assets/poly.svg"></img>
 }


</div>

}



{localStorage.getItem("red") == "mainnet" &&
<div className="dapp__red">
  
<p style={{"fontSize":"14px"}}>Ethereum</p>

{!id && 
<img style={{"width":"30px"}} src="../assets/rop.png"></img>
 }
 {id && 
<img style={{"width":"30px"}} src="../../assets/rop.png"></img>
 }

</div>

}

         </div>

         <div className="dapp__sections">
    <p>{name}</p>
      <Avatar 
        onClick={handleClick}  alt={name} src={(img)}/>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >

      <MenuItem disabled >Conectado en: {localStorage.getItem("red")}</MenuItem>
        <MenuItem onClick={goToProfile}>Mi Perfil</MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>



         </div>
        
    </div>
    )
}
